import { all, AllEffect } from 'redux-saga/effects';
import OrdersReducer from './duck/reducer';
import { watchGetOrders } from './duck/saga';

function* OrdersSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetOrders()]);
}

export { OrdersReducer, OrdersSaga };
